import { type ComponentProps } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { IconLink } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsBackButton = (props: Props) => {
  const { formatMessage } = useIntl();

  return (
    <View style={styles.container} pointerEvents="box-none">
      <IconLink
        name="IconArrowLeft"
        palette="dark-kale"
        iconSize={24}
        width={BUTTON_SIZE}
        height={BUTTON_SIZE}
        accessibilityLabel={formatMessage(messages.back)}
        {...props}
      />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  back: {
    defaultMessage: 'Go back',
    description: 'Product Details | Back button label',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const BUTTON_SIZE = 40;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: theme.spacing['5'],
    left: theme.spacing['6'],
    zIndex: 1,
    backgroundColor: theme.colors.CREAM,
    borderRadius: BUTTON_SIZE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<ComponentProps<typeof IconLink>, 'name' | 'accessibilityLabel'>;
